import { Action, combineReducers } from '@ngrx/store';

import * as RoadTypes from './roadTypes/reducer';
import * as RoadType from './roadType/reducer';
import * as Towns from './towns/reducer';
import * as Town from './town/reducer';
import * as Genders from './genders/reducer';
import * as Gender from './gender/reducer';
import * as HomeTypes from './homeTypes/reducer';
import * as HomeType from './homeType/reducer';
import * as FloorNumbers from './floorNumbers/reducer';
import * as FloorNumber from './floorNumber/reducer';
import * as AlarmTypes from './alarmTypes/reducer';
import * as AlarmType from './alarmType/reducer';
import * as HomeRegimes from './homeRegimes/reducer';
import * as HomeRegime from './homeRegime/reducer';
import * as HomeUses from './homeUses/reducer';
import * as HomeUse from './homeUse/reducer';
import * as FinancialEntityNames from './financialEntityNames/reducer';
import * as FinancialEntityName from './financialEntityName/reducer';

export const featureKey = 'catalog';

export interface CatalogState {
  [RoadTypes.featureKey]: RoadTypes.State;
  [RoadType.featureKey]: RoadType.State;
  [Towns.featureKey]: Towns.State;
  [Town.featureKey]: Town.State;
  [Genders.featureKey]: Genders.State;
  [Gender.featureKey]: Gender.State;
  [HomeTypes.featureKey]: HomeTypes.State;
  [HomeType.featureKey]: HomeType.State;
  [FloorNumbers.featureKey]: FloorNumbers.State;
  [FloorNumber.featureKey]: FloorNumber.State;
  [AlarmTypes.featureKey]: AlarmTypes.State;
  [AlarmType.featureKey]: AlarmType.State;
  [HomeRegimes.featureKey]: HomeRegimes.State;
  [HomeRegime.featureKey]: HomeRegime.State;
  [HomeUses.featureKey]: HomeUses.State;
  [HomeUse.featureKey]: HomeUse.State;
  [FinancialEntityNames.featureKey]: FinancialEntityNames.State;
  [FinancialEntityName.featureKey]: FinancialEntityName.State;
}

export interface State {
  [featureKey]: CatalogState;
}

export const reducers = {
  [RoadTypes.featureKey]: RoadTypes.reducer,
  [RoadType.featureKey]: RoadType.reducer,
  [Towns.featureKey]: Towns.reducer,
  [Town.featureKey]: Town.reducer,
  [Genders.featureKey]: Genders.reducer,
  [Gender.featureKey]: Gender.reducer,
  [HomeTypes.featureKey]: HomeTypes.reducer,
  [HomeType.featureKey]: HomeType.reducer,
  [FloorNumbers.featureKey]: FloorNumbers.reducer,
  [FloorNumber.featureKey]: FloorNumber.reducer,
  [AlarmTypes.featureKey]: AlarmTypes.reducer,
  [AlarmType.featureKey]: AlarmType.reducer,
  [HomeRegimes.featureKey]: HomeRegimes.reducer,
  [HomeRegime.featureKey]: HomeRegime.reducer,
  [HomeUses.featureKey]: HomeUses.reducer,
  [HomeUse.featureKey]: HomeUse.reducer,
  [FinancialEntityNames.featureKey]: FinancialEntityNames.reducer,
  [FinancialEntityName.featureKey]: FinancialEntityName.reducer,
};

export function combiner(state: CatalogState | undefined, action: Action) {
  return combineReducers(reducers)(state, action);
}
